import styled from 'styled-components';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 6.5rem 2rem;

  overflow-y: auto;

  height: 70rem;
  max-height: 100%;
`;

const Content = styled.div`
  width: 117rem;
  height: 59rem;
  padding: 8rem 1.5rem;
`;

export { Wrapper, Content };
